(function () {

  'use strict';

  angular.module('mgpCorregedoriaApp.validacao').controller('RelatorioVistaAbertaCorregedoria', RelatorioVistaAbertaCorregedoria);

  function RelatorioVistaAbertaCorregedoria($state, DataService,  toaster, i18n,
    FiltroRelatorio30DiasValidator, PeriodoService, RelatorioVistaAbertaService,
    ParametroService) {

      var vm = this;

      vm.init = init;
      vm.convertDate = convertDate;
      vm.convertDate = convertDate;
      vm.filtrarRelatorioVistaAberta = filtrarRelatorioVistaAberta;
      vm.detalheRelatorioVistaAbertaPromotor = detalheRelatorioVistaAbertaPromotor;
      vm.options = {
        type:"pie",
        width:"24",
        height:"24",
        sliceColors:['#016FB0','#2C3E50', '#924AB0']
      };

      const FORMATO_ANO_MES = 'YYYYMM';

      vm.init();

      function convertDate(date) {
        return  DataService.convertDate(date);
      }

      function init() {
        if ($state.params.referer === 'botaoVoltar') {
          vm.periodoInicial = $state.params.filtros.periodoInicial;
          vm.periodoFinal = $state.params.filtros.periodoFinal;
          vm.qtdDias = $state.params.filtros.diasEmAtraso;
          vm.frequencia = $state.params.filtros.frequencia;
          vm.reconhecido = $state.params.filtros.totalReconhecidos;
          vm.impugnado = $state.params.filtros.totalImpugnados;
          vm.semJustificativa = $state.params.filtros.totalSemJustificativa;

          filtrarRelatorioVistaAberta();
        }

        vm.periodoRelatorioEnviadoList = PeriodoService.loadPeriodosFiltro();

        ParametroService.getLimiteDiasFeitosVistaAberta(moment().format(FORMATO_ANO_MES)).then(data => {
          vm.qtdDias = vm.qtdDias || data.quantidadeDias;
          vm.parametro = {
            quantidadeDias: data.quantidadeDias
          };
        });
      }

      function detalheRelatorioVistaAbertaPromotor(nomePromotor, pessDk){
        $state.go('relatorioVistaAbertaPromotor', {
          periodoInicial: vm.periodoInicial,
          periodoFinal: vm.periodoFinal,
          nomePromotor: nomePromotor,
          pessDk: pessDk,
          filtros: {
            periodoInicial: vm.periodoInicial,
            periodoFinal: vm.periodoFinal,
            diasEmAtraso: vm.qtdDias,
            frequencia: vm.frequencia,
            totalReconhecidos: vm.reconhecido,
            totalImpugnados: vm.impugnado,
            totalSemJustificativa: vm.semJustificativa,
          }
        });
      }

      function filtrarRelatorioVistaAberta(){
        vm.filter = {
          periodoInicial: vm.periodoInicial,
          periodoFinal: vm.periodoFinal,
          diasEmAtraso: vm.qtdDias,
          frequencia: vm.frequencia,
          totalReconhecidos: vm.reconhecido,
          totalImpugnados: vm.impugnado,
          totalSemJustificativa: vm.semJustificativa,
          tipo : "Corregedoria"
        };

        var erros = FiltroRelatorio30DiasValidator.getErrors (vm.filter);

        erros.map(function (erro) {
          toaster.pop('error', i18n.translate(erro));
        });

        if (!erros.length) {
          RelatorioVistaAbertaService.retornaRelatorioVistaAbertaCorregedoria(vm.filter)
          .then(function (data) {
            vm.feitosByPromotoresList = data;

            if (vm.feitosByPromotoresList === null || vm.feitosByPromotoresList.length === 0) {
              toaster.pop('error', i18n.translate('relatorio.vista.aberta'),
              i18n.translate('label.nao.existem.registros')
            );
          }
        });
      }
    }
  }

})();
